module.exports = "/pages/business/foodstadium/success-story-bg-2.png";